<template>
  <div class="ai-container" style="height:100%">
    <!-- <div>AI</div>
    <ul>
      <li>1</li>
      <li>2</li>
      <li>3</li>
    </ul> -->
    <iframe src="https://www.oschip.cloud:9400/Agent" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "AIComponent",
  data() {
    return {
      checkList: ["A"],
    };
  },
  mounted() {},
  computed: {},
};
</script>

<style></style>
